export default "__VITE_ASSET__Bl_JUO9O__"